














































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { Unit, UserLogin } from "@/types";
//import { SkriningResponseItem } from "@/types/mpp";
import MppModule from "@/store/modules/MppStore";

@Component({
  components: {
    VCDateTimePicker
  }
})
export default class SkriningMppInput extends Vue {
  @Prop({ default: null }) value!: any;
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ default: false }) readonly isReadonly!: boolean;

  private isInternalChange = false;
  isTidakAdaAsuhan = false;

  private formError: any = {
    authored_at: null
  };

  unitRanapId = this.stateUser?.unit_id || null;
  unitRanap = this.stateUser?.unit || null;
  authored_at: string | Date = new Date();
  user: UserLogin | null = null;
  unit: Unit | null = null;
  user_id = this.stateUser?.id || null;
  category = "skrining";
  id = null;

  private formAspects: any[] = [];

  get aspects() {
    return this.formAspects;
  }

  localAspects() {
    const skriningOptions = MppModule.getSkriningOption || [];

    this.formAspects = skriningOptions.map(item => {
      return {
        id: String(item.id),
        judul: item.title,
        risikoId: [],
        options: (item.options || []).map(o => ({
          text: o.text,
          value: String(o.id)
        }))
      };
    });
  }

  async mounted() {
    if (!MppModule.skriningOptions || MppModule.skriningOptions.length === 0) {
      try {
        await MppModule.fetchSkriningOptions();
      } catch (e) {
        console.error("Gagal load opsi:", e);
      }
    }

    this.localAspects();

    if (this.value) {
      this.getData(this.value);
    }
  }

  aspects2 = [
    {
      id: "0",
      judul: "Tidak Ada Resiko",
      risikoId: [],
      //risikoText: "",
      options: [{ text: "Tidak Diperlukan Asuhan MPP", value: "1" }]
    },
    {
      id: "1",
      judul: "Resiko Tinggi",
      risikoId: [],
      //risikoText: "",
      options: [
        { text: "Pelayanan Inadekuat", value: "1" },
        { text: "Risiko readmisi", value: "2" },
        { text: "Risiko komplain", value: "3" },
        { text: "Risiko melarikan diri", value: "4" }
      ]
    },
    {
      id: "2",
      judul: "Risiko Masalah Pembiayaan",
      risikoId: [],
      //risikoText: "",
      options: [
        {
          text: "Pasien tanpa asuransi dengan kebutuhan sumber daya tinggi",
          value: "1"
        },
        { text: "Pasien tanpa asuransi dengan minimal coverage", value: "2" },
        { text: "Pasien dengan pembayaran/penjaminan belum jelas", value: "3" },
        {
          text: "Pasien dengan asuransi kesehatan bermasalah / non aktif",
          value: "4"
        },
        { text: "Pasien dengan masalah hukum/proses pengadilan", value: "5" },
        {
          text: "Kasus dengan LOS lebih dari rencana rawat dalam CP",
          value: "6"
        },
        {
          text: "Kasus yang diprediksi membutuhkan waktu perawatan yang lama",
          value: "7"
        },
        {
          text: "Pasien yang diperbolehkan pulang tertunda karena administrasi",
          value: "8"
        }
      ]
    },
    {
      id: "3",
      judul: "Risiko Pelayanan Komplek",
      risikoId: [],
      //risikoText: "",
      options: [
        { text: "Kasus multi diagnostik", value: "1" },
        { text: "Kasus multi provider", value: "2" },
        { text: "Kasus dengan banyak tindakan medis", value: "3" },
        { text: "Pasien paliative Care", value: "4" },
        { text: "Pasien dengan DNR", value: "5" }
      ]
    },
    {
      id: "4",
      judul: "Risiko Permasalahan Psikososial",
      risikoId: [],
      //risikoText: "",
      options: [
        { text: "Pasien Tanpa identitas", value: "1" },
        { text: "Pasien tunawisma", value: "2" },
        { text: "Pasien ODGJ", value: "3" },
        { text: "Pasien dengan riwayat dan risiko penelantaran", value: "4" },
        { text: "Support sistem keluarga rendah", value: "5" }
      ]
    }
  ];

  get aspekAdaAsuhan() {
    return this.aspects.filter(aspek => String(aspek.id) !== "42"); // sembunyikan id 42  "Tidak Ada Resiko"
  }

  get stateUser() {
    return userModule.user;
  }

  risikoShow() {
    // Saat checkbox dicentang (true), isi data Aspek ID 42 secara otomatis
    if (this.isTidakAdaAsuhan) {
      this.aspects.forEach(a => {
        // Reset semua array
        a.risikoId = [];
        //a.risikoText = "";

        // Jika ID 0, isi otomatis dengan value "1" (Tidak Diperlukan Asuhan MPP)
        if (a.id === "42") {
          a.risikoId = ["1"];
        }
      });
    } else {
      // Jika uncheck, bersihkan semua agar user memilih ulang dari awal
      this.aspects.forEach(a => {
        a.risikoId = [];
        //a.risikoText = "";
      });
    }
  }

@Watch("isTidakAdaAsuhan")
@Watch("authored_at")
@Watch("aspects", { deep: true })
onInternalDataChange() {
   
    if (this.authored_at) {
      this.formError.authored_at = null;
    }

    this.isInternalChange = true;
    this.$emit("input", this.sendData);
    
    this.$nextTick(() => {
      this.isInternalChange = false;
    });
  }

  @Watch("value", { immediate: false })
  onValueChange(val: any) {
    if (this.isInternalChange) return;

    if (!val) {
      this.resetForm();
      return;
    }

    if (this.formAspects.length > 0) {
      this.getData(val);
    }
  }

  @Watch("MppModule.skriningOptions")
  onStoreDataChange(val: any) {
    console.log("Data store terupdate:", val);
    this.localAspects();
  }

  get sendData() {
    const content: any[] = [];

    this.aspects.forEach(a => {
      if (a.risikoId.length > 0) {
        content.push({
          id: a.id,
          judul: a.judul,
          risiko: a.options
            .filter(o => {
              return a.risikoId.includes(String(o.value));
            })
            .map(o => ({
              id: String(o.value),
              text: o.text
            }))
        });
      }
    });

    return {
      id: this.id,
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.stateUser?.unit_id || null,
      user_id: this.stateUser?.id || null,
      unit: {
        id: this.unitRanapId || this.unit?.id,
        nama: this.unitRanap || this.unit?.nama || "-"
      },
      user: {
        id: this.user?.id || this.stateUser?.id,
        nama: this.user?.nama || this.stateUser?.nama || "-"
      },
      authored_at: moment(this.authored_at).format("YYYY-MM-DD HH:mm:ss"),
      category: this.category ? this.category : "skrining",
      content: content
    };
  }

  getData(dataApi: any) {
    if (!dataApi) return;

    this.id = dataApi.id || null;
    this.authored_at = dataApi.authored_at
      ? new Date(dataApi.authored_at)
      : new Date();

    const content = Array.isArray(dataApi.content) ? dataApi.content : [];

    this.aspects.forEach(a => (a.risikoId = []));

    // Cek ID 42 (Tidak Ada Resiko)
    this.isTidakAdaAsuhan = content.some((c: any) => String(c.id) === "42");

    content.forEach((c: any) => {
      const aspect = this.aspects.find(a => String(a.id) === String(c.id));
      if (aspect && c.risiko) {
        // Pastikan c.risiko array sebelum map
        const risikoArray = Array.isArray(c.risiko) ? c.risiko : [];
        aspect.risikoId = risikoArray.map((r: any) => String(r.id));
      }
    });
  }

  resetForm() {
    this.id = null;
    this.isTidakAdaAsuhan = false;
    this.authored_at = new Date();
    this.aspects.forEach(a => {
      a.risikoId = [];
      //a.risikoText = "";
    });
    this.unit = {
      id: this.stateUser?.unit_id,
      nama: this.stateUser?.unit
    };
    this.user = {
      id: this.stateUser?.id,
      nama: this.stateUser?.nama
    };
    this.unitRanapId = this.stateUser?.unit_id;
    this.unitRanap = this.stateUser?.unit;
  }

  // inputLainnya(aspect: any) {
  //   if (aspect.risikoId.includes("9")) {
  //     this.$nextTick(() => {
  //       const fields = this.$refs.refLainnya as any[];
  //       if (fields?.length) fields[fields.length - 1]?.focus();
  //     });
  //   } else {
  //     aspect.risikoText = "";
  //   }
  // }

  datetimeInput() {
    const dtime = new Date();
    if (this.authored_at > dtime) {
      this.$nextTick(() => {
        this.authored_at = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

    public validasi(): boolean {
    this.formError.authored_at = null;

    if (!this.authored_at) {
      this.formError.authored_at = "Tanggal & Jam Pencatatan wajib diisi";
      return false;
    }
    return true;
  }
}
